import * as React from 'react';
import * as classNames from 'classnames';
import { Icon } from '@ridi/rsg';
import { Item } from '../Notice';

interface Props {
  item: Item;
}

interface State {
  expandable: boolean;
  expanded: boolean;
}

export class NoticeItem extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      expandable: !!this.props.item.content,
      expanded: false,
    };
  }

  handleToggle = () => {
    if (!this.state.expandable) {
      return;
    }
    this.setState(prevState => {
      return { expanded: !prevState.expanded };
    });
  };

  render() {
    const { item } = this.props;

    const { expandable, expanded } = this.state;

    return (
      <li
        className={classNames(
          'BookDetailNotice_List_Item',
          'BookDetailNotice_List_Item-notice',
          {
            'BookDetailNotice_List_Item-expandable': expandable,
            'BookDetailNotice_List_Item-expanded': expanded,
          },
        )}
        onClick={this.handleToggle}
      >
        <div className="BookDetailNotice_List_Item_Title">
          {item.title}
          {expandable && (
            <Icon
              className="BookDetailNotice_List_Item_ArrowIcon"
              name={expanded ? 'arrow_2_up' : 'arrow_2_down'}
            />
          )}
        </div>
        {expanded && (
          <p
            className="BookDetailNotice_List_Item_Content"
            dangerouslySetInnerHTML={{ __html: item.content }}
          />
        )}
      </li>
    );
  }
}



// WEBPACK FOOTER //
// ./pages/bookDetail/components/Notice/items/NoticeItem.tsx